import { useEffect } from "react";

const getFirstAndLastFocusableElements = (element) => {
  if (element) {
    const focusableElements = element.querySelectorAll(
      "button:not([data-input-not-focus]):not([disabled]), input:not([data-input-not-focus]):not([disabled]), textarea:not([data-input-not-focus])"
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    return { firstElement, lastElement };
  }
  return {};
};

const useFocusFormElements = (element, mode) => {
  useEffect(() => {
    if (!element) return;
    const handleTabKeyPress = (event) => {
      const { firstElement = null, lastElement = null } =
        getFirstAndLastFocusableElements(element);
      if (!firstElement || !lastElement) return;
      if (event.key === "Tab") {
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    };
    document.addEventListener("keydown", handleTabKeyPress, true);

    return () =>
      document.removeEventListener("keydown", handleTabKeyPress, true);
  }, [element, mode]);
};

export default useFocusFormElements;
